import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  normalize(type, data) {
    // reverse what we do in serialize
    if (data.maximum_amount && data.price && data.price.currency_code) {
      data.maximum_amount = {
        cents: data.maximum_amount,
        currency_code: data.price.currency_code
      };
      // There is a server constraint that prevents price amount and maximum amount from being
      // on the same discount, so we can safely delete data.price at this point
      delete data.price;
    }
    return this._super(type, data);
  },
  serialize(snapshot) {
    const json = this._super(snapshot, {
      includeId: true
    });
    // the maximum amount and price attributes on the discount model share a single currency code attribute
    if (json.maximum_amount) {
      json.price = {
        currency_code: json.maximum_amount.currency_code
      };
      json.maximum_amount = json.maximum_amount.cents;
    }
    return json;
  }
});